/*
 *
 * LanguageProvider reducer
 *
 */
import { createReducer } from '@reduxjs/toolkit';

import { CHANGE_LOCALE, CHANGE_LANGUAGE, CHANGE_LANGUAGE_REQUEST, LANGUAGE_SELECT_MODAL } from './constants';
import { FETCH_TOKEN_DETAILS_SUCCESS } from '../App/constants';
const DEFAULT_LOCALE = 'en';

export const initialState = {
  locale: DEFAULT_LOCALE,
  language: 'en',
  languageSelectModal: false
};

const languageProviderReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(CHANGE_LOCALE, (state, action) => {
      state.locale = action.locale;
    })
    .addCase(CHANGE_LANGUAGE, (state, action) => {
      state.language = action.language;
      state.languageSelectModal = false;
    })
    .addCase(CHANGE_LANGUAGE_REQUEST, (state, action) => {
      state.language = action.language;
    })
    .addCase(LANGUAGE_SELECT_MODAL, (state, action) => {
      state.languageSelectModal = action.open;
    })
    .addCase(FETCH_TOKEN_DETAILS_SUCCESS, (state, action) => {
      state.language = action.response.language_preference || 'en';
    });
});

export default languageProviderReducer;
